import { render } from "./caseImageView.vue?vue&type=template&id=0532b591&scoped=true"
import script from "./caseImageView.vue?vue&type=script&lang=js"
export * from "./caseImageView.vue?vue&type=script&lang=js"

import "./caseImageView.vue?vue&type=style&index=0&id=0532b591&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0532b591"]])

export default __exports__